import { css } from '@emotion/react';
import React from 'react';
import svgs from '../../assets/svg';
import { breakpoints } from '../../utils/styleguide';

export type IconNames =
  | 'volume-mute'
  | 'volume-on'
  | 'hamburger'
  | 'milkywire-full'
  | 'milkywire-symbol'
  | 'milkywire-wordmark'
  | 'milkywire-logo-brand'
  | 'facebook'
  | 'facebook-rounded'
  | 'twitter'
  | 'instagram'
  | 'linkedin'
  | 'youtube'
  | 'mail'
  | 'long-arrow'
  | 'long-arrow-down'
  | 'x-filled'
  | 'x-cross'
  | 'x-ol'
  | 'lock'
  | 'lock-filled'
  | 'lock-check-filled'
  | 'check-filled'
  | 'chevron-down'
  | 'chevron-down-outline'
  | 'chevron-s-down-outline'
  | 'chevron-right'
  | 'clock'
  | 'camera'
  | 'video'
  | 'film'
  | 'download'
  | 'file-text'
  | 'x-symbol'
  | 'pangaia'
  | 'bee'
  | 'pangaia-bee'
  | 'pangaia-bee-text'
  | 'pangaia-bee-text-with-trail'
  | 'trail4'
  | 'pangaia-bee-trail'
  | 'map-marker-filled'
  | 'stripe'
  | 'pangaia-bee-trail2'
  | 'stripe-icon'
  | 'search'
  | 'klarna'
  | 'sustainable-development-goals'
  | 'arrow-left'
  | 'arrow-left-long'
  | 'arrow-right'
  | 'arrow-long-right'
  | 'arrow-down'
  | 'star'
  | 'apple-pay'
  | 'american-express'
  | 'american-express-solid'
  | 'mastercard'
  | 'mastercard-solid'
  | 'visa'
  | 'visa-solid'
  | 'paypal-solid'
  | 'default-card-icon'
  | 'archive'
  | 'solid-on-light'
  | 'external-link'
  | 'bin'
  | 'check'
  | 'rocket'
  | 'help-circle-fill'
  | 'right-up-circle-fill'
  | 'right-circle-fill'
  | 'right-down-circle-fill'
  | 'pause'
  | 'play'
  | 'plus'
  | 'edit'
  | 'info-outline';

type Props = {
  name: IconNames;
  fill?: string;
  stroke?: string;
  size?: number | string;
  desktopSize?: number | string;
  title?: string;
  onClick?: (event: React.MouseEvent) => void;
};

/**
 * @param {import('prop-types').InferProps<Icon.propTypes>} props
 */
const Icon = ({ name, desktopSize, size, fill, stroke, ...other }: Props) => {
  const IconToRender = svgs[name];
  if (!IconToRender) {
    // eslint-disable-next-line no-console
    console.warn(`Could not find icon with name: ${name}`);
    return null;
  }

  return (
    <IconToRender
      css={css`
        font-size: ${size}px;
        ${breakpoints.tablet} {
          font-size: ${desktopSize || size}px;
        }

        path {
          fill: ${fill};
          stroke: ${stroke};
        }

        circle {
          fill: ${fill};
        }
      `}
      {...other}
    />
  );
};

export default Icon;
